import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const VestDress = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.VestDress.itemName}
      name={SS23.tops.VestDress.itemName}
      price={SS23.tops.VestDress.itemPrice}
      fabric={SS23.tops.VestDress.itemFabric}
      src={SS23.tops.VestDress.sizeChart}
      divId={SS23.tops.VestDress.shopifyDivId}
      mainId={SS23.tops.VestDress.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.VestDress.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.VestDress.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default VestDress;
